import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import OverviewContainer from './OverviewContainer';
import AllOrdersContainer from './AllOrdersContainer';
import ProductsListContainer from './ProductsListContainer';
import DocumentsContainer from './DocumentsContainer';
import ProfilContainer from './ProfilContainer';
import ChangePasswordContainer from './ChangePasswordContainer';
import ProductDetailContainer from './ProductDetailContainer';
import ProductsImportContainer from './ProductsImportContainer';
import AdminContainer from './AdminContainer';
import RolesListContainer from './RolesListContainer';
import RoleDetailContainer from './RoleDetailContainer';
import PermissionsListContainer from './PermissionsListContainer';
import PermissionDetailContainer from './PermissionDetailContainer';
import UsersListContainer from './UsersListContainer';
import UserDetailContainer from './UserDetailContainer';
import UserNotificationsDetailContainer from './UserNotificationsDetailContainer';
import UserPermissionsDetailContainer from './UserPermissionsDetailContainer';
import AllClaimsContainer from './AllClaimsContainer';
import ClaimsImportContainer from './ClaimsImportContainer';
import OrdersImportContainer from './OrdersImportContainer';
import ProvidersListContainer from './ProvidersListContainer';
import ProviderConfigDetailContainer from './ProviderConfigDetailContainer';
import SystemContainer from './SystemContainer';
import SystemConfigDetailContainer from './SystemConfigDetailContainer';
import AllReturnsContainer from './AllReturnsContainer';
import AllReceivingsContainer from './AllReceivingsContainer';
import ClaimDetailContainer from './ClaimDetailContainer';
import ReceivingDetailContainer from './ReceivingDetailContainer';
import ReceivingImportContainer from './ReceivingImportContainer';
import ReturnDetailContainer from './ReturnDetailContainer';
import OrderDetailContainer from './OrderDetailContainer';
import OrderExpeditionPackagesContainer from './OrderExpeditionPackagesContainer';
import OrderExpeditionPackageDetailContainer from './OrderExpeditionPackageDetailContainer';
import TransportsListContainer from './TransportsListContainer';
import TransportDetailContainer from './TransportDetailContainer';
import TransportPackageTypesListContainer from './TransportPackageTypesListContainer';
import TransportPackageTypeDetailContainer from './TransportPackageTypeDetailContainer';
import GeisPackingTypesListContainer from './GeisPackingTypesListContainer';
import PalletTypesListContainer from './PalletTypesListContainer';
import GeisPackingTypeDetailContainer from './GeisPackingTypeDetailContainer';
import ProviderDetailContainer from './ProviderDetailContainer';
import OrderMessagesOnExpeditionBoxContainer from './OrderMessagesOnExpeditionBoxContainer';
import OrderMessagesOnExpeditionBoxDetailContainer from './OrderMessagesOnExpeditionBoxDetailContainer';
import TasksGridContainer from './TasksGridContainer';
import ProductSetsListContainer from './ProductSetsListContainer';
import ProductSetDetailContainer from './ProductSetDetailContainer';
import BillsOfMaterialsListContainer from './BillsOfMaterialsListContainer';
import BillOfMaterialsDetailContainer from './BillsOfMaterialDetailContainer';
import AllProductsContainer from './AllProductsContainer';
import ProductTrashListContainer from './ProductTrashListContainer';
import ConstantsListContainer from './ConstantsListContainer';
import ConstantDetailContainer from './ConstantDetailContainer';
import ProductCompletionSheetsListContainer from './ProductCompletionSheetsListContainer';
import ProductCompletionSheetDetailContainer from './ProductCompletionSheetDetailContainer';
import ProductStockTransfersDetailContainer from './ProductStockTransfersDetailContainer';
import SkladonMappingListContainer from './SkladonMappingListContainer';
import SkladonMappingDetailContainer from './SkladonMappingDetailContainer';
import WidgetListContainer from './WidgetListContainer';
import ReturnWidgetDetailContainer from './ReturnWidgetDetailContainer';
import ProviderCompaniesListContainer from './ProviderCompaniesListContainer';
import ProviderCompanyDetailContainer from './ProviderCompanyDetailContainer';
import ApplicationStatusMessagesListContainer from './ApplicationStatusMessagesListContainer';
import ApplicationStatusMessageDetailContainer from './ApplicationStatusMessageDetailContainer';
import EmailTemplatesContainer from './EmailTemplatesContainer';
import EmailTemplateDetailContainer from './EmailTemplateDetailContainer';
import ProviderTransferCompanyDetailContainer from './ProviderTransferCompanyDetailContainer';
import ProviderTransferCompaniesListContainer from './ProviderTransferCompaniesListContainer';
import IntegrationListContainer from './IntegrationListContainer';
import IntegrationDetailContainer from './IntegrationDetailContainer';
import CarriersListContainer from './CarriersListContainer';
import CarrierDetailContainer from './CarrierDetailContainer';
import EgonRoutesListContainer from './EgonRoutesListContainer';
import EgonRouteDetailContainer from './EgonRouteDetailContainer';
import WebhooksListContainer from './WebhooksListContainer';
import WebhookDetailContainer from './WebhookDetailContainer';
import WebhookRecordsListContainer from './WebhookRecordsListContainer';
import WebhookRecordDetailContainer from './WebhookRecordDetailContainer';
import WebhookHistoryListContainer from './WebhookHistoryListContainer';

export const AdminRoutes: FC = () => {
    return (
        <Routes>
            <Route path="/roles" element={<RolesListContainer />} />
            <Route path="/permissions" element={<PermissionsListContainer />} />
            <Route path="/providers" element={<ProvidersListContainer />} />
            <Route path="/system" element={<SystemContainer />} />
        </Routes>
    );
};

const RoutesContainer: FC = () => {
    return (
        <Routes>
            <Route path="/" element={<OverviewContainer />} />
            <Route path="/overview" element={<OverviewContainer />} />
            <Route path="/task_list" element={<TasksGridContainer />} />
            {/* <Route path="/orders/*" element={<OrdersContainer />} /> */}
            <Route path="/orders/import" element={<OrdersImportContainer />} />
            <Route path="/orders/new" element={<OrderDetailContainer />} />
            <Route path="/orders/:idOrder" element={<OrderDetailContainer />} />
            <Route path="/orders/:idOrder/returns/new" element={<ReturnDetailContainer />} />
            <Route path="/orders/:idOrder/claims/new" element={<ClaimDetailContainer />} />
            <Route path="/orders/:idOrder/clone" element={<OrderDetailContainer />} />
            <Route path="/orders" element={<AllOrdersContainer />} />
            <Route path="/orders/all" element={<AllOrdersContainer />} />
            <Route path="/orders/b2c" element={<AllOrdersContainer filter="b2c" />} />
            <Route path="/orders/b2b" element={<AllOrdersContainer filter="b2b" />} />
            <Route path="/orders/transfer" element={<AllOrdersContainer filter="transfer" />} />
            <Route path="/orders/cod" element={<AllOrdersContainer filter="cod" />} />
            <Route path="/orders/expedition_packages" element={<OrderExpeditionPackagesContainer />} />
            <Route
                path="/orders/expedition_packages/:idOrderExpeditionPackage"
                element={<OrderExpeditionPackageDetailContainer />}
            />
            <Route path="/orders/messages_on_expedition_box" element={<OrderMessagesOnExpeditionBoxContainer />} />
            <Route
                path="/orders/messages_on_expedition_box/new"
                element={<OrderMessagesOnExpeditionBoxDetailContainer />}
            />
            <Route
                path="/orders/messages_on_expedition_box/:idOrderMessagesOnExpeditionBox"
                element={<OrderMessagesOnExpeditionBoxDetailContainer />}
            />
            <Route path="/products/all" element={<AllProductsContainer filter="all" allProviders={false} />} />
            <Route path="/products/active" element={<AllProductsContainer filter="active" allProviders={false} />} />
            <Route path="/products/inactive"
                   element={<AllProductsContainer filter="inactive" allProviders={false} />} />
            <Route path="/products/deleted"
                   element={<AllProductsContainer filter="deleted" allProviders={false} />} />
            <Route path="/products/promoMaterials"
                   element={<AllProductsContainer filter="promoMaterial" allProviders={false} />} />
            <Route
                path="/products/packgingMaterials"
                element={<AllProductsContainer filter="packagingMaterial" allProviders={false} />}
            />
            <Route path="/products/all/all"
                   element={<AllProductsContainer filter="all" allProviders={true} />} />
            <Route path="/products/active/all"
                   element={<AllProductsContainer filter="active" allProviders={true} />} />
            <Route path="/products/inactive/all"
                   element={<AllProductsContainer filter="inactive" allProviders={true} />} />
            <Route path="/products/deleted/all"
                   element={<AllProductsContainer filter="deleted" allProviders={true} />} />
            <Route path="/products/promoMaterials/all"
                   element={<AllProductsContainer filter="promoMaterial" allProviders={true} />} />
            <Route
                path="/products/packgingMaterials/all"
                element={<AllProductsContainer filter="packagingMaterial" allProviders={true} />}
            />
            <Route path="/products/all/withStock" element={<ProductsListContainer filter="all" />} />
            <Route path="/products/active/withStock" element={<ProductsListContainer filter="active" />} />
            <Route path="/products/inactive/withStock" element={<ProductsListContainer filter="inactive" />} />
            <Route path="/products/deleted/withStock" element={<ProductsListContainer filter="deleted" />} />
            <Route path="/products/packgingMaterials/withStock"
                   element={<ProductsListContainer filter="packagingMaterial" />} />
            <Route path="/products/promoMaterials/withStock"
                   element={<ProductsListContainer filter="promoMaterial" />} />
            <Route path="/products/trash" element={<ProductTrashListContainer />} />
            <Route path="/products/import" element={<ProductsImportContainer />} />
            <Route path="/products/new" element={<ProductDetailContainer />} />
            <Route path="/products/sets" element={<ProductSetsListContainer />} />
            <Route path="/products/sets/new" element={<ProductSetDetailContainer />} />
            <Route path="/products/sets/:skuProductSet" element={<ProductSetDetailContainer />} />
            <Route path="/products/bill_of_materials" element={<BillsOfMaterialsListContainer />} />
            <Route path="/products/bill_of_materials/new" element={<BillOfMaterialsDetailContainer />} />
            <Route path="/products/bill_of_materials/:idBillOfMaterials" element={<BillOfMaterialsDetailContainer />} />
            <Route path="/products/stockTransfers/:idProduct" element={<ProductStockTransfersDetailContainer />} />
            <Route path="/products/:idProduct/bill_of_materials" element={<BillsOfMaterialsListContainer />} />
            <Route path="/products/:idProduct/bill_of_materials/new" element={<BillOfMaterialsDetailContainer />} />
            <Route
                path="/products/:idProduct/bill_of_materials/:idBillOfMaterials"
                element={<BillOfMaterialsDetailContainer />}
            />
            <Route path="/products/:idProduct" element={<ProductDetailContainer />} />
            <Route path="/documents" element={<DocumentsContainer />} />
            <Route path="/integration" element={<IntegrationListContainer />} />
            <Route path="/integration/:idProvider" element={<IntegrationDetailContainer />} />
            <Route path="/users" element={<UsersListContainer />} />
            <Route path="/users/new" element={<UserDetailContainer />} />
            <Route path="/users/:idUser" element={<UserDetailContainer />} />é
            <Route path="/users/notifications/:idUser" element={<UserNotificationsDetailContainer />} />
            <Route path="/users/permissions/:idUser" element={<UserPermissionsDetailContainer />} />
            <Route path="/profil" element={<ProfilContainer />} />
            <Route path="/changePassword" element={<ChangePasswordContainer />} />
            <Route path="/admin/roles" element={<RolesListContainer />} />
            <Route path="/admin/roles/new" element={<RoleDetailContainer />} />
            <Route path="/admin/roles/:idRole" element={<RoleDetailContainer />} />
            <Route path="/admin/permissions" element={<PermissionsListContainer />} />
            <Route path="/admin/permissions/new" element={<PermissionDetailContainer />} />
            <Route path="/admin/permissions/:idPermission" element={<PermissionDetailContainer />} />
            <Route path="/admin/*" element={<AdminContainer />} />
            <Route path="/admin/providers" element={<ProvidersListContainer />} />
            <Route path="/admin/providers/new" element={<ProviderDetailContainer />} />
            <Route path="/admin/providers/:idProvider" element={<ProviderDetailContainer />} />
            <Route path="/admin/providers/config/:idProvider" element={<ProviderConfigDetailContainer />} />
            <Route path="/admin/providers/integration-config/:idProvider" element={<ProviderConfigDetailContainer integrationConfig={true} />} />
            <Route path="/admin/carriers" element={<CarriersListContainer />} />
            <Route path="/admin/carriers/new" element={<CarrierDetailContainer />} />
            <Route path="/admin/carriers/:idCarrier" element={<CarrierDetailContainer />} />
            <Route path="/admin/egon-routes" element={<EgonRoutesListContainer />} />
            <Route path="/admin/egon-routes/new" element={<EgonRouteDetailContainer />} />
            <Route path="/admin/egon-routes/:idEgonRoute" element={<EgonRouteDetailContainer />} />

            <Route path="/admin/system" element={<SystemContainer />} />
            <Route path="/admin/system/config" element={<SystemConfigDetailContainer />} />
            <Route path="/admin/constants" element={<ConstantsListContainer />} />
            <Route path="/admin/constants/:constantKey" element={<ConstantDetailContainer />} />
            <Route path="/admin/email_templates" element={<EmailTemplatesContainer />} />
            <Route
                path="/admin/email_templates/new"
                element={<EmailTemplateDetailContainer newEmailTemplate />}
            />
            <Route
                path="/admin/email_templates/:idEmailTemplate"
                element={<EmailTemplateDetailContainer />}
            />
            <Route path="/admin/application_status_messages" element={<ApplicationStatusMessagesListContainer />} />
            <Route
                path="/admin/application_status_messages/new"
                element={<ApplicationStatusMessageDetailContainer />}
            />
            <Route
                path="/admin/application_status_messages/:idApplicationStatusMessage"
                element={<ApplicationStatusMessageDetailContainer />}
            />
            <Route path="/settings/provider_companies" element={<ProviderCompaniesListContainer />} />
            <Route path="/settings/provider_companies/new" element={<ProviderCompanyDetailContainer />} />
            <Route
                path="/settings/provider_companies/:idProviderCompany"
                element={<ProviderCompanyDetailContainer />}
            />
                <Route path="/settings/provider_transfer_companies" element={<ProviderTransferCompaniesListContainer />} />
                <Route path="/settings/provider_transfer_companies/new" element={<ProviderTransferCompanyDetailContainer />} />
                <Route
                    path="/settings/provider_transfer_companies/:idProviderTransferCompany"
                    element={<ProviderTransferCompanyDetailContainer />}
                />
            <Route path="/settings/webhooks" element={<WebhooksListContainer />} />
            <Route path="/settings/webhooks/new" element={<WebhookDetailContainer />} />
            <Route path="/settings/webhooks/:idWebhook" element={<WebhookDetailContainer />} />
            <Route path="/settings/webhook_records" element={<WebhookRecordsListContainer />} />
            <Route path="/settings/webhook_records/:eventId" element={<WebhookRecordDetailContainer />} />
            <Route path="/settings/webhook_history" element={<WebhookHistoryListContainer />} />
            <Route path="/claims" element={<AllClaimsContainer />} />
            <Route path="/claims/import" element={<ClaimsImportContainer />} />
            <Route path="/claims/new" element={<ClaimDetailContainer />} />
            <Route path="/claims/:idClaim" element={<ClaimDetailContainer />} />
            <Route path="/returns" element={<AllReturnsContainer />} />
            <Route path="/returns/new" element={<ReturnDetailContainer />} />
            <Route path="/returns/:idReturn" element={<ReturnDetailContainer />} />
            <Route path="/receivings" element={<AllReceivingsContainer />} />
            <Route path="/receivings/new" element={<ReceivingDetailContainer />} />
            <Route path="/receivings/:idReceiving" element={<ReceivingDetailContainer />} />
            <Route path="/receivings/:idReceiving/confirm" element={<ReceivingDetailContainer confirm />} />
            <Route path="/receivings/import" element={<ReceivingImportContainer />} />
            <Route path="/transports" element={<TransportsListContainer />} />
            <Route path="/transports/new" element={<TransportDetailContainer />} />
            <Route path="/transports/package-types" element={<TransportPackageTypesListContainer />} />
            <Route path="/transports/package-types/new" element={<TransportPackageTypeDetailContainer />} />
            <Route
                path="/transports/package-types/:ssrcCode"
                element={<TransportPackageTypeDetailContainer />}
            />
            <Route path="/transports/pallet-types" element={<PalletTypesListContainer />} />
            <Route path="/transports/geis-packing-types" element={<GeisPackingTypesListContainer />} />
            <Route
                path="/transports/geis-packing-types/:code"
                element={<GeisPackingTypeDetailContainer />}
            />
            <Route path="/transports/:idTransport" element={<TransportDetailContainer />} />
            <Route path="/commands/product_completion_sheets" element={<ProductCompletionSheetsListContainer />} />
            <Route path="/commands/product_completion_sheets/new" element={<ProductCompletionSheetDetailContainer />} />
            <Route
                path="/commands/product_completion_sheets/:idProductCompletionSheet"
                element={<ProductCompletionSheetDetailContainer />}
            />
            <Route path="*" element={<div>404</div>} />
        </Routes>
    );
};

export default RoutesContainer;
